module.exports = __webpack_public_path__ + "img/cargo-boxes-storing-at-warehouse-shelves-P7R6YYC.edb24f79.jpg";